export const Homework = {
    "生成个人作业":"生成個人作業",
    "生成小组作业":"生成小組作業",
    "小组作业":"小組作業",
    "个人作业":"個人作業",
    "评审型作业":"評審型作業",
    "查重警戒值":"查重警戒值",
    "共":"共",
    "人":"人",
    "暂无学号":"暫無學號",
    "提交时间":"提交時間：",
    "超":"超",
    "查重":"查重",
    "未交":"未交",
    "已催交":"| 已催交",
    "次":"次",
    "打回时间":"| 打回時間",
    "成员":"",
    "提交状态":"提交狀態",
    "正常":"正常",
    "超时交":"超时交",
    "字数":"字數",
    "第一次作业":"第壹次作業",
    "创建于2020/01/09 12:09":"創建於2020/01/09 12:09",
    "已阅":"已閱",
    "查重设置":"查重设置",
    "是否查重":"是否查重",
    "未填写":"未填寫",
    "查重率高过上限自动打回":"查重率高過上限自動打回",
    "查重率上限":"查重率上限",
    "截至时间设置":"截至時間設置",
    "是否限制截止时间":"是否限制截止時間",
    "日期":"日期",
    "若超时禁止提交":"若超時,禁止提交",
    "具体时间":"具體時間",
    "选择日期":"選擇日期",
    "满分值":"滿分值",
    "总分设置":"總分設置",
    "新建个人作业":"新建個人作業",
    "新建小组作业":"新建小組作業",
    "作业标题":"作業標題",
    "作业详情":"作業詳情",
    "未开启查重":"未開啟查重",
    "开启查重":"開啟查重",
    "小组批次":"小組批次",
    "个人":"個人",
    "小组":"小组",
    "请选择截止时间":"請選擇截止時間",
    "分值设置":"分值設置",
    "评语要求":"評語要求：",
    "至少":"至少",
    "字":"字",
    "批阅设置":"批閱設置",
    "批阅人":"批閱人",
    "作业批阅分配方式":"作業批閱分配方式",
    "每份作业一个人批阅":"每份作業壹個人批閱",
    "每份作业随机":"每份作業隨機",
    "人批阅":"人批閱",
    "匿名评审":"匿名評審",
    "评审批阅时学生信息匿名展示":"評審批閱時學生信息匿名展示",
    "评分方式":"評分方式",
    "取平均值":"取平均值",
    "去掉最高分和最低分取平均值":"去掉最高分和最低分，取平均值",
    "筛选":"篩選",
    "批阅状态":"批閱狀態：",
    "条数据":"條數據",
    "暂时无数据":"暫時無數據～",
    "全选本页":"全選本頁",
    "催交":"催交",
    "请确认是否要催交作业":"請確認是否要催交作業？",
    "不催了":"不催了",
    "立即催交":"立即催交",
    "共选择了":"共選擇了",
    "等共":"，等共",
    "学生催交的学生将会收到催交信息":"學生，催交的學生將會收到催交信息",
    "位":"位",
    "组":"組",
    "已批组":"已批組",
    "未批组":"未批組",
    "未交组":"未交組",
    "催交成功":"催交成功",
    "提交作业":"提交作業",
    "更新提交":"更新提交",
    "更新提交被打回":"更新提交（被打回）",
    "查看批阅":"查看批閱",
    "请先加入小组":"請先加入小組",
    "完成本次小组作业需要先参与进行本次作业所要求的分组任务并加入某一小组":"完成本次小組作業，需要先參與進行本次作業所要求的分組任務，並加入某壹小組。",
    "重置":"重置",
    "按时交":"按时交",
    "整体查重率":"整體查重率",
    "文件列表":"文件列表",
    "点击文件可查看重复段落每次作业":"點擊文件可查看重復段落，每次作業",
    "点击文件可查看重复段落每个文档":"點擊文件可查看重復段落，每個文檔",
    "仅有一次机会":"僅有壹次機會",
    "有5次机会":"有5次機會",
    "有10次机会":"有10次機會",
    "查重率":"查重率",
    "确定使用查看重复段落的机会吗":"確定使用查看重復段落的機會嗎?",
    "本次作业只有1次查看1个文件的机会":"本次作業只有1次查看1個文件的機會",
    "本次作业只有 1 次查看机会并且只能查看所有提交的文件中的 1 个附件文件的重复段落请慎重决定":"本次作業，只有 1 次查看機會，並且只能查看所有提交的文件中的 1 個附件文件的重復段落。請慎重決定！",
    "作业查重信息":"作業查重信息",
    "查重规则":"查重規則",
    "仍要查看":"仍要查看",
    "已无查看重复段落的机会":"已無查看重復段落的機會!",
    "查看重复片段机会已用完":"查看重復片段機會已用完!",
    "文件格式不支持查重":"文件格式不支持查重",
    "暂无重复段落":"暫無重復段落",
    "表示查重还没有完毕其他同学还未提交作业文件格式不支持查看视频和图片":"表示查重還沒有完畢；其他同學還未提交作業；文件格式不支持查看（視頻和圖片）",
    "查重率是动态变化的任何同学新提交的作业都会导致查重率的改变有多个文档时以最大查重率文档为基准字数也是一样的规则":"查重率是動態變化的，任何同學新提交的作業都會導致查重率的改變。有多個文檔時，以最大查重率文檔為基準，字數也是壹樣的規則。",
    "给分":"給分",
    "打回":"打回",
    "请确认是否要打回作业":'請確認是否要打回作業？',
    "学生的作业":"學生的作業",
    "选填打回理由":"(選填）打回理由",
    "批量给分":"批量給分",
    "请输入分数":"請輸入分數",
    "请至少勾选一个作业":"請至少勾選壹個作業",
    "对学生隐藏成绩":"對學生隱藏成績",
    "审评截止":"審評截止：",
    "批量操作":"批量操作",
    "再次催交":"再次催交",
    "移动端暂不支持批阅请前往电脑端查看批阅详情":"移動端暫不支持批閱，請前往電腦端查看批閱詳情",
    "已显示":"已顯示",
    "已隐藏":"已隐藏",
    "批阅作业":"批閱作業",
    "批阅":"批閱",
    "未批阅":"未批閱",
    "批阅小组作业":"批閱小組作業",
    "统一给分":"統壹給分",
    "老师评语":"老師評語",
    "请输入对学生的评语":"請輸入對學生的評語",
    "学生作业":"學生作業",
    "提交历史":"提交歷史",
    "手机仅支持浏览请在电脑端添加批注":"手機僅支持瀏覽，請在電腦端添加批註",
    "查看批注":"查看批註",
    "学生留言":"學生留言",
    "暂无留言":"暫無留言",
    "上一位":"上壹位",
    "上一组":"上壹組",
    "下一位":"下壹位",
    "下一组":"下壹組",
    "打回学生作业":"打回學生作業",
    "分享学生作业":"分享學生作業",
    "分享小组作业":"分享小組作業",
    "已批阅的同学才能看到防止抄袭":"已批閱的同學才能看到，防止抄襲",
    "匿名分享名称显示为***学生":"匿名分享，名稱顯示為（***學生）",
    "匿名分享名称显示为***小组":"匿名分享，名稱顯示為（***小組）",
    "选填分享理由":"（選填）分享理由...",
    "给学生打分":"給學生打分",
    "请打分":"請打分",
    "作业批阅":"作業批閱",
    "取消分享":"取消分享",
    "发表成功":"發表成功",
    "成绩已变更":"成績已變更",
    "已分享":"已分享",
    "确认取消分享该作业":"確認取消分享該作業？",
    "已取消分享":"已取消分享",
    "这是第一个学生作业":"這是第壹個學生作業",
    "已经是最后一个学生作业":"已經是最後壹個學生作業",
    "组长":"組長",
    "暂无小组成员":"暫無小組成員~",
    "已交名单":"已交名單",
    "作业提交成功请耐心等待老师批阅":"作業提交成功，請耐心等待老師批閱",
    "作业被老师打回请重新上传":"作業被老師打回，請重新上傳",
    "打回理由":"打回理由",
    "已批阅成绩未发布":"已批閱，成績未發布",
    "已批阅成绩":"已批閱，成績",
    "查看重复率":"查看重復率",
    "系统默认查看":"*系統默認查看",
    "已分享作业":"已分享作業",
    "提交详情":"提交詳情",
    "看谁交了":"看誰交了",
    "课后作业":"課後作業",
    "作业附件":"作業附件",
    "作业留言":"作業留言",
    "支付单次查重费用":"支付單次查重費用",
    "确定支付":"確定支付",
    "开通会员每月低至2元即可无限查重":"開通會員，每月低至2元，即可無限查重 >>",
    "升级会员尊享更多vip权益":"升级会员，尊享更多vip权益 >",
    "元次":"元/次",
    "立即提交":"立即提交",
    "立即提交已超时":"立即提交（已超時）",
    "重新提交":"重新提交",
    "重新提交已超时":"重新提交（已超時）",
    "更新提交已超时":"更新提交（已超時）",
    "查看作业":"查看作業",
    "温馨提醒":"溫馨提醒",
    "确定要更新作业吗":"確定要更新作業嗎",
    "当前时间已超过作业提交截止时间重新提交的作业将被标为超时交":"當前時間已超過作業提交截止時間，重新提交的作業將被標為超時交。",
    "去更新":"去更新",
    "更新作业":"更新作业?",
    "更新作业并提交之后作业的提交时间将以现在的时间为准":"更新作業並提交之後，作業的提交時間將以現在的時間為準！",
    "此功能仅对VIP用户开放开通VIP后可实时查看同班同学提交作业的情况另外还可享受更多VIP权益":"此功能僅對VIP用戶開放，開通VIP後可實時查看同班同學提交作業的情況，另外還可享受更多VIP權益",
    "支付成功":"支付成功",
    "小组成员":"小組成員",
    "提交次数":"提交次數",
    "暂无作业提交":"暫無作業提交~",
    "分享理由":"分享理由",
    "暂无分享作业":"暫無分享作業~",
    "系统默认查重":"*系統默認查重",
    "添加作业":"添加作業",
    "作业必须以附件的方式提交":"*作業必須以附件的方式提交",
    "添加留言作业要以附件的形式提交而不是写在留言里":"添加留言，作業要以附件的形式提交，而不是寫在留言裏",
    "提交完成":"提交完成",
    "正在保存答案请稍后提交":"正在保存答案,請稍後提交",
    "题未作答是否提交":"題 未作答，是否提交？",
    "继续提交":"繼續提交",
    "再等等":"再等等",
    "您已选择":"您已選擇",
    "项少选了":"項，少選了",
    "AI批阅评语":"AI批閱評語",
    "参考答案设置":"參考答案設置",
    "答案内容":"答案內容",
    "参考答案附件":"參考答案附件",
    "答案公布时间":"答案公布時間",
    "不设置":"不設置",
    "作业参考答案":"作業參考答案",
    "答案将于指定时间公布":"答案將於 {time} 公布",
    "高级问题作业":"高級問題作業",
    "总题目":"總題目",
    "进度":"進度",
    "步骤":"步驟",
    "得分":"得分",
    "最终得分":"最終得分",
    "AI追问":"AI追問",
    "本步尚未通过":"本步尚未通過",
    "本步得分":"本步得分",
    "本步评语":"本步評語",
    "追问进度":"已追問 {current}/{max} 次",
    "追问后请修改回答再提交":"請根據 AI 追問修改下方回答，然後再次點擊「再次提交本步」。達到最大追問次數後將自動進入下一步。",
    "请根据评语修改回答再提交":"請根據上方評語修改下方回答，然後再次點擊「再次提交本步」。",
    "再次提交本步":"再次提交本步",
    "修改回答后再次提交":"修改回答後，點擊下方「再次提交本步」",
    "本步尚未通过请修改后再提交":"本步尚未通過，請查看 AI 反饋並修改回答後再提交",
    "AI学习助手":"AI學習助手",
    "我的回答":"我的回答",
    "请输入你的回答":"請輸入你的回答",
    "暂存":"暫存",
    "提交本步":"提交本步",
    "已完成全部步骤":"已完成全部步驟",
    "已暂存":"已暫存",
    "暂存失败":"暫存失敗",
    "提交失败请重试":"提交失敗，請重試",
    "AI助手暂不可用":"AI助手暫不可用，請直接作答",
    "正在加载AI助手":"正在載入AI助手...",
    "AI助手VIP未开通学生提示":"AI 學習助手暫不可用，請提醒任課老師開通 AI 智能體使用權限",
    "AI助手VIP过期学生提示":"AI 學習助手暫不可用，請提醒任課老師續費開通",
    "智能体平台未开通提示":"高級問題作業依賴智能體平台，請先前往開通後再使用",
    "智能体平台已失效提示":"智能體平台已失效，請前往續費後再使用",
    "AI助手使用说明":"與 AI 討論思路；在「作答」中填寫正式回答並點擊「提交本步」",
    "AI助手欢迎语":"同學你好！我們正在攻克「{stepTitle}」這一步。先別急著要答案——說說你現在的想法或卡住的地方，哪怕只是一點點直覺也行，我會一步步陪你把它想清楚。",
    "AI助手快捷提问_1":"我還不太理解這一步要做什麼",
    "AI助手快捷提问_2":"我有初步想法，但不確定對不對",
    "AI助手快捷提问_3":"請給我一個不直接給答案的提示",
    "回答公式说明":"支持 Markdown 與 LaTeX；可點「預覽」查看排版與公式",
    "作答":"作答",
    "AI助手":"AI助手",
    "预览":"預覽",
    "返回编辑":"返回編輯",
    "点击返回编辑":"點擊此處返回編輯",
    "收起预览":"收起預覽",
    "继续作答":"繼續作答",
    "查看作答":"查看作答",
    "进入作答":"進入作答",
    "教师评语":"教師評語",
    "移动端暂不支持高级问题批阅请前往电脑端":"移動端暫不支持高級問題作業批閱，請前往電腦端操作",
    "高级问题作业请在电脑端配置":"高級問題作業的分步配置與批閱請使用電腦端",
    "当前步骤":"當前步驟",
    "已完成步骤":"已完成步驟",
    "展开题目":"展開題目",
    "收起题目":"收起題目",
    "本步要求":"本步要求",
    "插入公式":"插入公式",
    "公式输入占位":"輸入 LaTeX，如 \\frac{a}{b} 或 x^{2}",
    "块级公式":"塊級公式（居中顯示）",
    "插入":"插入",
    "取消":"取消",
}
